    
<template>
  <common-page-layout>
    <span slot="fixedtopbuttons">
      <back-button @click="$router.push('/admin/home')" />      
      <large-button  @click="openAddStaffDialog()">Add Person</large-button>
      <large-button  @click="refresh()">Refresh</large-button>
    </span>
    <h4>Edit Staff rights</h4>    
    <p>
        <font color="green"><b>Here you can Add/Change Staff access rights..</b></font>
    </p>
    
    <ul class="w3-ul w3-panel w3-border w3-round-large">        
          <li :key="id" v-for="(staffmember, id) in businessstaff" @click="openStaffDialog(id,staffmember)">            
              <font color="green"><i class="fa fa-user" style="font-size:48px;"></i></font> {{staffmember.knownAs || staffmember.token}}
          </li>         
    </ul>

    <dialog-layout ref="staffdialog" id="staffdialog" @click="dialogActions">    
       
        <h3 slot="headercontent">Manage User</h3>       

        <span v-if="selectedstaffmember">   
          <span v-if="!selectedstaffmember.id && !enableqrcode">
            <p>    
              <font color="red"><b>Enter in users token exactly, for security reasons you cannot search for a user. A user will appear in your list if you have rights to add this user and the token is correct. The token can be found in their profile page.</b></font>          
            </p>  

            <p>        
              <input type="text" placeholder="enter in users token exactly" class="w3-input w3-border w3-round-xxlarge" v-model="selectedstaffmember.token"/>
            </p>
            
          </span>         
          <large-button-wide v-if="selectedstaffmember && !selectedstaffmember.id" @click="enableqrcode = !enableqrcode">QR Reader ({{enableqrcode?'Hide':'Show'}})</large-button-wide> 
          <qrcode-reader v-if="enableqrcode" @decode="onDecode"></qrcode-reader>

          <p v-if="selectedstaffmember && selectedstaffmember.id && selectedstaffmember.token">
            <label class="w3-text-grey">Code</label><label> : <b>{{selectedstaffmember.token}}</b></label>            
          </p>                         
          
          <font color="green"><b>Enter in user friendly name.</b></font>          
          <p>
            <input class="w3-input w3-border" placeholder="I know this person as..." type="text" v-model="selectedstaffmember.knownAs"/>           
          </p>
           <p>
             <label class="w3-text-grey">Installer
                <input id="default" class="w3-check" type="checkbox" v-model="selectedstaffmember.rights.installer">            
             </label>
          </p> 
          <p>
             <label class="w3-text-grey">Manage Remedials
                <input id="default" class="w3-check" type="checkbox" v-model="selectedstaffmember.rights.createremedials">            
             </label>
          </p>                   
          <p>
             <label class="w3-text-grey">Read Admin rights
                <input id="default" class="w3-check" type="checkbox" v-model="selectedstaffmember.rights.read">            
             </label>
          </p>
          <p>
             <label class="w3-text-grey">Edit Admin rights
                <input id="default" class="w3-check" type="checkbox" v-model="selectedstaffmember.rights.write">            
             </label>
          </p>
          <p>
             <label class="w3-text-grey">Allow Image Uploads
                <input id="default" class="w3-check" type="checkbox" v-model="selectedstaffmember.rights.allowimageupload">            
             </label>
          </p>
          
          <p v-if="selectedstaffmember">
            <large-button v-if="!selectedstaffmember.id && selectedstaffmember.token" @click="saveStaffDetails();closedialog()">Add</large-button>
            <large-button v-if="selectedstaffmember.id"  @click="saveStaffDetails();closedialog()">Save</large-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <large-button v-if="selectedstaffmember.id"  @click="removeStaffMember();closedialog()">Remove</large-button>            
          </p>
        </span>  

    </dialog-layout>
  
  </common-page-layout>
</template>


<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  // var mounted=true;
  export default {
    data: function() {
      return {     
        enableqrcode:false,   
        selectedstaffmember:null,
        businessstaff:null
      };
    },
    methods: {
      onDecode (decodedString) {
        this.enableqrcode = false   
        if(decodedString)     
          this.selectedstaffmember.token = decodedString
        // console.log(decodedString)       
      },
      dialogActions(e){
        if(e.action==="canceldialog")
        {
          this.selectedstaffmember = null 
          this.enableqrcode = false
        }        
      },
      closedialog(){
        this.$refs.staffdialog.cancelDialog()                
      },
      openStaffDialog(id,staffmember){
          this.selectedstaffmember = {id,...staffmember} 
          this.$refs.staffdialog.show()                
      },
      openAddStaffDialog(){
          this.selectedstaffmember = {id:null,knownAs:null,rights:{}} 
          this.$refs.staffdialog.show()                  
      }, 
      
      removeStaffMember(){          
          this.groupCommands({command:'removeUser',...this.selectedstaffmember})          
      },
      saveStaffDetails(){
          if(this.selectedstaffmember.id)
            this.groupCommands({command:'updateUser',...this.selectedstaffmember})
          else
            this.groupCommands({command:'addUser',...this.selectedstaffmember})
      },
      refresh(){
        if(!this.business)
          return 

        this.getBusinessStaff(this.business.id).then((staff)=>{
          this.businessstaff = staff
        })
      },
      ...mapActions(["groupCommands","createGuidKey","getBusinessStaff"])
    },
    computed: {
      ...mapGetters(["business"])
    },
    created(){        
      this.refresh()
    },
    mounted: () => {     
    }
  };
</script>
 
<style>
  .groups {
    padding-top: 10px;
  }
  .dialogcontent {
      padding-top: 10px;
      padding-bottom: 10px;
  }
  textarea {
    width: 100%;
    height: 150px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    resize: none;
  }
  
  .description {
    padding-bottom: 10px;
    text-align: center;
  }
  
  .groupings {
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminStoreStaffGroups.vue